import type { Chain } from "viem/chains";

import { isValidInjectiveAddress, isValidSolanaAddress, isValidSuiAddress } from "@/lib/utils/is-true";

import type { ChainConfig } from "./types";

// https://docs.expand.network/ids/chain-ids
export const solana = { id: 900 } as const;
export const sui = { id: 101 } as const;
const injective = { id: 1776 } as const;

export const SVM_CHAIN_CONFIGS: Record<number, ChainConfig> = {
  [solana.id]: {
    chain: {
      id: solana.id,
      name: "Solana",
    } as Chain, // We're only using a subset of the full chain config values for non-EVM chains
    features: {},
    icon: "solana.svg",
    isEvm: false,
    isTestnet: false,
    prettyName: "Solana",
    validationFunc: isValidSolanaAddress,
  },
};

export const SUI_CHAIN_CONFIGS: Record<number, ChainConfig> = {
  [sui.id]: {
    chain: {
      id: sui.id,
      name: "Sui",
    } as Chain, // We're only using a subset of the full chain config values for non-EVM chains
    features: {},
    icon: "sui.svg",
    isEvm: false,
    isTestnet: false,
    prettyName: "Sui",
    validationFunc: isValidSuiAddress,
  },
};

export const INJECTIVE_CHAIN_CONFIGS: Record<number, ChainConfig> = {
  [injective.id]: {
    chain: {
      id: injective.id,
      name: "Injective",
    } as Chain, // We're only using a subset of the full chain config values for non-EVM chains
    features: {},
    icon: "injective.svg",
    isEvm: false,
    isTestnet: false,
    prettyName: "Injective",
    validationFunc: isValidInjectiveAddress,
  },
};
export const NON_EVM_CHAIN_CONFIGS: Record<number, ChainConfig> = {
  ...SVM_CHAIN_CONFIGS,
  ...SUI_CHAIN_CONFIGS,
  ...INJECTIVE_CHAIN_CONFIGS,
};

export const SVM_SUPPORTED_CHAIN_IDS = [solana.id];
export const SUI_SUPPORTED_CHAIN_IDS = [sui.id];
// we don't support injective anymore, so empty array
export const INJECTIVE_SUPPORTED_CHAIN_IDS: number[] = [];
